// extracted by mini-css-extract-plugin
export default {"formArea":"ContactUs_formArea__FMKIj","form":"ContactUs_form__tFHPZ","formBg":"ContactUs_formBg__fadOx"};